import React, { useEffect, useContext } from 'react';
import { withStyles } from '@mui/styles';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import AdminNavbar from './AdminNavbar';
import AdminAppRouter from '../Router/AdminAppRouter';
import Banner from '../../components/HeaderComponents/Banner/Banner';
import Footer from '../../Shared/Components/Footer';
import { COLORS } from '../../utils/Application_Constants';
import { AdminAuthContext } from '../Contexts/AdminAuthContext';

const styles = (theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '800px',
    },
    pageRoot: {
        display: 'flex',
        flexDirection: 'column',
        background: COLORS.LT_MIDNIGHTBG1,
        minHeight: 'calc(100vh - 210px)',
        [theme.breakpoints.up('md')]: {
            minHeight: 'calc(100vh - 230px)',
        },
    },
    isLoadingRoot: {
        height: '100vh',
    },
});

const AdminLayout = (props) => {
    const { classes } = props;

    const { userInformation = {} } = useContext(AdminAuthContext) || {};

    const ldClient = useLDClient();

    useEffect(() => {
        if (userInformation.email) {
            ldClient.identify({ key: userInformation.email, name: userInformation.email });
        }
    }, [userInformation]);

    return (
        <div className={classes.root}>
            <AdminNavbar />
            <Banner pageName="" />
            <div className={classes.pageRoot}>
                <AdminAppRouter />
            </div>
            <Footer />
        </div>
    );
};

export default withStyles(styles)(AdminLayout);
